var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwimmingPool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 152,
    viewBox: "0 0 153 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3826 43.4581L95.4994 101.334C81.7769 101.334 77.6007 94.0951 63.2819 86.8574C51.8269 81.0668 35.8375 82.032 31.0646 83.2385L50.2628 69.6656C52.2164 68.2843 53.1932 67.5939 53.5054 66.5426C53.8175 65.4913 53.3759 64.3791 52.4927 62.1559L49.8056 55.3911C48.8008 52.8615 48.2983 51.5968 47.3903 50.6793C47.0739 50.3597 46.7245 50.0747 46.3477 49.8291C45.2664 49.124 43.9264 48.8864 41.2465 48.4108L20.6593 44.7582C16.3244 43.9891 13.166 40.221 13.166 35.8184C13.166 30.2876 18.0692 26.0416 23.5432 26.8323L51.3832 30.8531C56.3976 31.5773 58.9048 31.9394 60.996 33.1347C61.8677 33.633 62.6771 34.2332 63.4071 34.9226C65.1582 36.5764 66.233 38.8703 68.3826 43.4581Z",
    stroke: "url(#paint0_linear_16269_6359)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.834 82.3335C131.327 82.3335 139.834 73.8269 139.834 63.3335C139.834 52.8401 131.327 44.3335 120.834 44.3335C110.341 44.3335 101.834 52.8401 101.834 63.3335C101.834 73.8269 110.341 82.3335 120.834 82.3335Z",
    stroke: "url(#paint1_linear_16269_6359)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 114.534C19.8512 92.1672 49.6999 102.433 73.3327 114.534C96.9655 126.635 120.833 134.335 133.499 114.534",
    stroke: "url(#paint2_linear_16269_6359)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16269_6359",
    x1: -45.173,
    y1: -17.5845,
    x2: 129.195,
    y2: 116.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1478,
    stopColor: "#F6ED9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#EADB88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5877,
    stopColor: "#D6BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8463,
    stopColor: "#BB9643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16269_6359",
    x1: 74.9083,
    y1: 21.7556,
    x2: 161.151,
    y2: 82.0519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1478,
    stopColor: "#F6ED9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#EADB88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5877,
    stopColor: "#D6BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8463,
    stopColor: "#BB9643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16269_6359",
    x1: -72.0988,
    y1: 86.2816,
    x2: -38.2963,
    y2: 198.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1478,
    stopColor: "#F6ED9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#EADB88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5877,
    stopColor: "#D6BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8463,
    stopColor: "#BB9643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmingPool);
export default __webpack_public_path__ + "static/media/swimming-pool.3c1950bff93633cd1f98e9e79673a923.svg";
export { ForwardRef as ReactComponent };